import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const emptyApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_SYSTEM_SELECTOR_API_URL,
    credentials: 'include'
  }),
  tagTypes: [
    'StructureStepsCompleted',
    'QuotableSystems',
    'AccessoriesRecommendations',
    'QuoteData',
    'SizingLoad',
    'CustomSystems',
    'ErrorLogs'
  ],
  endpoints: () => ({})
});
